<template>
  <div v-show="password">
    {{ checkStrength }}
    <div style="display: flex">
      <div class="point" />
      <div class="point" />
      <div class="point" />
      <div class="point" />
    </div>
    <div class="mt-2">
      <label>{{ strength }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasswordStrengthBar",
  props: {
    password: {
      Type: String,
      default: "",
    },
  },
  data() {
    return {
      colors: ["#F00", "#F90", "#FF0", "#0F0"],
      status: ["Muito Fraca", "Fraca", "Média", "Forte"],
      strength: "",
      colorIdxByStrength: {
        10: 0,
        20: 1,
        30: 2,
        40: 3,
      },
    };
  },
  computed: {
    checkStrength() {
      const c = this.getColor(this.mesureStrength(this.password));
      const pointsDiv = Array.from(document.querySelectorAll(".point"));
      pointsDiv.forEach((e) => {
        e.style.background = "#DDD";
      });
      const points = pointsDiv.slice(0, c.idx);
      points.forEach((e) => {
        e.style.background = c.col;
      });

      this.strength = c.status;
    },
  },
  methods: {
    mesureStrength(p) {
      const minLength = 8;

      let _force = 0;
      const _numbers = /[0-9]+/.test(p);
      const _lowerLetters = /[a-z]+/.test(p);
      const _upperLetters = /[A-Z]+/.test(p);
      const _specialCharacter = /\W/.test(p);
      const _whiteSpace = /\s/g.test(p);

      const _flags = [
        _lowerLetters,
        _upperLetters,
        _numbers,
        _specialCharacter,
      ];

      const _passedMatches = _flags
        .map((e) => e === true)
        .filter((e) => e).length;

      _force += _passedMatches * 10;
      _force = _passedMatches == 1 ? Math.min(_force, 10) : _force;
      _force = _passedMatches == 2 ? Math.min(_force, 20) : _force;
      _force = _passedMatches == 3 ? Math.min(_force, 40) : _force;
      _force = p.length < minLength ? Math.min(_force, 10) : _force;
      _force = !_whiteSpace ? _force : 0;

      return _force;
    },
    getColor(s) {
      const idx = this.colorIdxByStrength[s];

      return {
        idx: idx + 1,
        col: this.colors[idx],
        status: this.status[idx],
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/public/password/PasswordStrengthBar.vue